<template>
  <div class="col-12 ">
    <div class="card mb-5" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">{{ t('assignmentForm.addTitle') }}</h6>
          </div>
        </div>
      </div>
   
      <div class="card-body px-0 pb-2 pe-3">
        <div class="row justify-content-center">
          <div class="col-12">
            <AssignmentForm 
              ref="assignmentForm"
              :title="t('assignmentForm.addTitle')"
              :submit-text="t('assignmentForm.addButton')"
              :loading="isSubmitting"
              @submit="handleSubmit" 
              @cancel="handleCancel" 
              @validation-error="handleValidationError"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import AssignmentForm from '@/components/features/assignments/AssignmentForm.vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';

const { t } = useI18n(); 
const toast = useToast();
const router = useRouter();
const store = useStore();
const assignmentForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
    isSubmitting.value = true;
    try {
        await store.dispatch('assignments/createAssignment', formData);
        toast.success(t('assignmentForm.successAdd'));
        router.push('/assignments');
    } catch (error) {
        if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            for (const field in errors) {
                toast.error(errors[field][0]);
            }
        } else {
            toast.error(error.response?.data?.message || t('assignmentForm.errorAdd'));
        }
    } finally {
        isSubmitting.value = false;
    }
};

const handleValidationError = () => {
  toast.warning(t('assignmentForm.fillAllFields'));
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push('/assignments');
  }
};
</script>
